import { EarlyWarningTableWidgetDataWarningsInnerLevelEnum } from "@/lib/api";
import { EarlyWarningTableToggles } from "@/features/shared/widgets/early-warning-table/early-warning-table";
import { getPercentage } from "@/features/shared/widgets/early-warning-table/utils";

import Styled from "./styles";

interface EarlyWarningTableCellProps {
  level?: EarlyWarningTableWidgetDataWarningsInnerLevelEnum;
  percentage?: number;
  multiple: boolean;
  variant: EarlyWarningTableToggles;
  onClick?: () => void;
}

const EarlyWarningTableCell = ({
  level,
  percentage,
  multiple,
  variant,
  onClick,
}: EarlyWarningTableCellProps) => {
  return (
    <Styled.ValueElement
      className="ValueElement"
      level={level}
      multiple={multiple}
      onClick={onClick}
    >
      <Styled.ValueElementIndicator className="ValueElementIndicator" level={level} />
      {variant === EarlyWarningTableToggles.TABLE && (
        <Styled.ValueElementLabel className="ValueElementLabel">
          {getPercentage(percentage)}
        </Styled.ValueElementLabel>
      )}
    </Styled.ValueElement>
  );
};

export default EarlyWarningTableCell;
